import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../service/managers/storage.service';
import { Config } from '../component_dependent/config';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService extends Config {

  constructor(private httpClient: HttpClient, private storage: StorageService) {
    super();
  }


  public getForms(tbl_name){
    var url = "maintenance?table_name=" + tbl_name
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }

  public getTableForm(){
    var url = "get_tables_form"
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }


  //Saving Records
  public saveRecords(tbl:any){
    var url = "save_maintenance"
    return this.httpClient.post(this.BASE_URL + url,tbl,this.storage.getHeaders())
  }

  //Get Records 
  public getRecords(tbl,maxItemsPerPage,page,keyword){
    var url = "get_maintenance_records?table_name=" + tbl + "&maxItemsPerPage=" + maxItemsPerPage + "&page=" + page + "&keyword=" + keyword
    
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }
  


  public getTables(){
    var url = "get_tables"
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }

  public getColumns(tblName){
    var url = "get_columns?table_name=" + tblName
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }

  public saveTables(tbl){
    var arr:any = {
      'data': tbl
      }
    var url = "save_tables"
    return this.httpClient.post(this.BASE_URL + url,arr,this.storage.getHeaders())
  }

}
